import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type ServiceDisplayClasses = 'disclaimer' | 'newLink';

const serviceDisplayStyles = makeStyles<ISpcTheme, ServiceDisplayClasses>(
  theme => ({
    disclaimer: {
      color: `${theme.palette.secondary.dark}`,
    },
    newLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
      padding: '8px 0',
    },
  }),
  { name: 'Customise_Feature_ServiceDisplay' },
);

export default serviceDisplayStyles;
